import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tanar',
  templateUrl: './tanar.component.html',
  styleUrls: ['./tanar.component.scss'],
})
export class TanarComponent  implements OnInit {

  compMod
  rw
  compData = {
    osztaly: 
      [{
        title: "Új osztály létrhozása",
        titleIcon: "assets/icon/icons8-class-96.png",
      },
      {
        title: "Osztály módosítása",
        titleIcon: "assets/icon/icons8-class-96.png",
      },
      {
        title: "Osztály törlése",
        titleIcon: "assets/icon/icons8-class-96.png",
      }]
    ,
    tantargy: [
      {
        title: "Új tantárgy létrhozása",
        titleIcon: "assets/icon/icons8-open-copybook-96.png",
      },
      {
        title: "Tantárgy módosítása",
        titleIcon: "assets/icon/icons8-open-copybook-96.png",
      },
      {
        title: "Tantárgy törlése",
        titleIcon: "assets/icon/icons8-open-copybook-96.png",
      }
    ],
    tanterem: [{
      title: "Új tanterem létrhozása",
      titleIcon: "assets/icon/icons8-door-96.png",
    },
    {
      title: "Tanterem módosítása",
      titleIcon: "assets/icon/icons8-door-96.png",
    },
    {
      title: "Tanterem törlése",
      titleIcon: "assets/icon/icons8-door-96.png",
    }],
    tanar: {
      title: "Tanárok",
      titleIcon: "assets/icon/icons8-employee-96.png",

    },
    allomany: {
      title: "Állomány",
      titleIcon: "assets/icon/icons8-employee-96.png",

    }
  };

  constructor() { }

  ngOnInit() {}

}
